<template>
    <ErrorPage>
        <template slot="Title">
            Something is missing!
        </template>
        <template slot="SubTitle">
            To generate your first planning, you will need:
        </template>
        <template slot="Content">
            <div class="helper-container">
                <RequiredActionItem :state="hasBox?'success':'pending'">
                    <template>
                        <span>A <a href="#" @click.prevent.stop="$router.push({name:'BoxList', params:{boxType:'MUSIC'}});">music box</a> including your music files</span>
                    </template>
                </RequiredActionItem>
                <RequiredActionItem :state="!hasBox?'disabled':(hasClock?'success':'pending')">
                    <template>
                        <span>A <a href="#" @click.prevent.stop="$router.push({name:'ClocksHome'})">clock</a> containing your music boxes</span>
                    </template>
                </RequiredActionItem>
                <RequiredActionItem :state="!hasDayTemplate?'disabled':(hasDayTemplate?'success':'pending')">
                    <template>
                        <span>A <a href="#" @click.prevent.stop="$router.push({name:'DayTemplatesHome'})">day template</a> containing containing your clocks and playlists</span>
                    </template>
                </RequiredActionItem>
            </div>
        </template>
        <template slot="Actions">
            <Button v-if="!hasBox" :empty="true" @click.prevent.stop="$router.push({name:'BoxList', params:{boxType:'MUSIC'}});">Back to music boxes</Button>
            <Button v-else="!hasClock" :empty="true" @click.prevent.stop="$router.push({name:'ClocksHome'})">Back to clocks</Button>
            <Button v-else="!hasDayTemplate" :empty="true" @click.prevent.stop="$router.push({name:'DayTemplatesHome'})">Back to day templates</Button>
        </template>
    </ErrorPage>
</template>

<script>
    import store from '@/store'
    import router from '@/router'
    import RequiredActionItem from'@/components/common/RequiredActionItem.vue'
    import Button from'@/components/common/Button.vue'
    import ErrorPage from'@/components/common/ErrorPage.vue'
    import { mapState, mapMutations, mapActions } from 'vuex';

    export default {
        name: "StuckedCard",
        store, router,
        components: {
            Button, RequiredActionItem, ErrorPage
        },
        computed: {
            ...mapState({
                hasClock: function () { return store.state.stationClocks != null && store.state.stationClocks.count > 0; },
                hasBox: function () { return store.state.stationBoxes != null && store.state.stationBoxes.count > 0; },
                hasDayTemplate: function () { return store.state.stationDayTemplates != null && store.state.stationDayTemplates.count > 0; }
            })
        },
        methods: {}
    }
</script>

<style scoped>
</style>